import React from 'react';

const AddProject =React.lazy(()=>import('./AddProject'));
const ProjectList=React.lazy(()=>import('./ProjectList'));
const ProjectViewPage = React.lazy(()=>import('./ProjectViewPage'));
const AdminProjectTitle=React.lazy(()=>import('./AdminProjectTitle'));
const AdminProjectInfo=React.lazy(()=>import('./AdminProjectInfo'));
const AdminEmpDocument= React.lazy(()=>import('./AdminEmpDocument'));
const AdminClientDocument= React.lazy(()=>import('./AdminClientDocument'));
export {
    AddProject,
    ProjectList,
    AdminProjectTitle,
    AdminProjectInfo,
    AdminEmpDocument,
    AdminClientDocument,
    ProjectViewPage
}